import { render, staticRenderFns } from "./EditOrganizationPointOfContactModal.vue?vue&type=template&id=192748a4&"
import script from "./EditOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"
export * from "./EditOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192748a4')) {
      api.createRecord('192748a4', component.options)
    } else {
      api.reload('192748a4', component.options)
    }
    module.hot.accept("./EditOrganizationPointOfContactModal.vue?vue&type=template&id=192748a4&", function () {
      api.rerender('192748a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/point-of-contact/EditOrganizationPointOfContactModal.vue"
export default component.exports